import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { RowViewComponent } from "../bolting-data-detail/rowViewComponent";
import { useStepperContext } from "../../providers/StepperProvider";
import { useEffect, useState } from "react";
import { DesignItProgress } from "@design-it/react-library";
import { PageContent } from "../../components/PageContent/PageContent";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/userSlice"; 
import { fetchLiveAnalysisDataById } from "../../store/liveAnalysisSlice";
import { ModelConfig, ModelConfigs } from "../AnalysisPage/types";



export const LiveAnalysisDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectCurrentUser); // Re-add variable
  const configData = useAppSelector(state => state.user.modelConfigs);
  const configLoadingStatus = useAppSelector(state => state.user.modelConfigLoadingStatus);
  const liveAnalysisStatus = useAppSelector(state => state.liveAnalysis.status);
  const liveAnalysisData = useAppSelector(state => state.liveAnalysis.dataById);
  const [modelConfig, setModelConfig] = useState<ModelConfig | undefined>();

  const [searchParams] = useSearchParams();
  const configName = searchParams.get("configName")!;

  const { setShowStepper } = useStepperContext();

  useEffect(() => {
    setShowStepper(false);
  }, [setShowStepper]);

  useEffect(() => {
    if (id && currentUser) {
      dispatch(fetchLiveAnalysisDataById({ id }));
    }
  }, [dispatch, id, currentUser]);

  useEffect(() => {
    (async () => {
      const data: ModelConfigs = configData as ModelConfigs;
      if(data) {
        setModelConfig(data[configName]);
      }
    })();
  }, [configLoadingStatus, configData, configName]); 

  return (
    <PageContent
      showButtonBar={true}
      backButton={{
        handler: () => navigate(-1),
        text: "Go back", 
      }}
    >
      {liveAnalysisStatus === 'loadingById' ? (
        <Box
          className="w-full h-full flex justify-center items-center flex-col"
          data-testid="loading"
        >
          <DesignItProgress indeterminate />
        </Box>
      ) : liveAnalysisData ? ( 
        <Box className="h-full" data-testid="content">
          <RowViewComponent
            modelConfig={modelConfig}
            modelExists={true}
            nonMlFlow={false}
            selectedRow={liveAnalysisData} 
            liveAnalysisView={true}
          />
        </Box>
      ) : null} 
    </PageContent>
  );
};
